import {
  KeyboardDateTimePicker,
  MuiPickersUtilsProvider,
  DateTimePicker
} from "@material-ui/pickers";
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { FieldRenderProps } from "react-final-form";
import { commonsStoreContext } from "../../../../model/CommonsStore";
import MomentUtils from "@date-io/moment";

export interface DatePickerProps extends FieldRenderProps<any> {
  autoOk?: boolean;
  /** If true shows "Clear" button for nonKeyboard calendar dialog */
  clearable?: boolean;
  customDateFormat?: string;
  disableFuture?: boolean;
  error?: boolean;
  label?: string;
  /** Allows local date formatting */
  locale?: any;
  /** Prohibits keyboard input, by using DateTimePicker instead of KeyboardDateTimePicker component */
  useSimplePicker?: boolean;
  maxDate?: number;
  minDate?: number;
  placeholder?: string;
  showTodayButton?: boolean;
  touched?: boolean;
}

/**
 * Date picker based on mui-pickers (https://material-ui-pickers.dev/), using moment-js for date operations
 * */
export const DatePickerComponent = observer((props: DatePickerProps) => {
  const { dateFormat } = useContext(commonsStoreContext).defaults;
  const {
    input: { name, onChange, value },
    useSimplePicker,
    clearable,
    customDateFormat,
    disableFuture,
    error,
    label,
    locale,
    minDate,
    maxDate,
    placeholder,
    readOnly,
    showTodayButton,
    touched,
    ...rest
  } = props;

  const format = customDateFormat || dateFormat;

  const renderLabel = (date: any) => {
    if (date && date.isValid()) {
      return date.format(format);
    } else {
      return "";
    }
  };

  return (
    <MuiPickersUtilsProvider utils={MomentUtils} locale={locale}>
      {useSimplePicker ? (
        <DateTimePicker
          name={name}
          clearable={clearable}
          {...rest}
          format={format}
          ampm={false}
          error={error && touched}
          disabled={readOnly}
          disableFuture={disableFuture || false}
          fullWidth={true}
          label={label}
          margin="dense"
          minDate={minDate}
          maxDate={maxDate}
          onChange={onChange}
          labelFunc={renderLabel}
          placeholder={placeholder || ""}
          readOnly={readOnly}
          showTodayButton={showTodayButton}
          inputVariant={"outlined"}
          value={value ? new Date(value) : null}
        />
      ) : (
        <KeyboardDateTimePicker
          name={name}
          clearable={clearable}
          {...rest}
          format={format}
          ampm={false}
          error={error && touched}
          disabled={readOnly}
          disableFuture={disableFuture || false}
          fullWidth={true}
          label={label}
          margin="dense"
          minDate={minDate}
          maxDate={maxDate}
          onChange={onChange}
          labelFunc={renderLabel}
          placeholder={placeholder || ""}
          readOnly={readOnly}
          showTodayButton={showTodayButton}
          inputVariant={"outlined"}
          value={value ? new Date(value) : null}
        />
      )}
    </MuiPickersUtilsProvider>
  );
});
